import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITermExam, IListAssignmentReqBody, IInitState } from "../interfaces";

const initialState = {
  loading: false,
  data: [],
  error: "",
};

const newListAssignmentSlice = createSlice({
  name: "termExamList",
  initialState,
  reducers: {
    newListAssignmentRequest(
      state: IInitState,
      action: PayloadAction<IListAssignmentReqBody>
    ) {
      state.loading = true;
    },
    newListAssignmentSuccess(
      state: IInitState,
      action: PayloadAction<ITermExam[]>
    ) {
      state.loading = false;
      state.data = action.payload;
    },
  },
});

export const { newListAssignmentRequest, newListAssignmentSuccess } =
  newListAssignmentSlice.actions;
export default newListAssignmentSlice.reducer;
